import { useModal } from '@ebay/nice-modal-react';
import { modalIds } from '@shared/config/modal-ids';
import type { IVacancy } from '@entities/vacancy';

export const useVacancyInfoModal = () => {
  const modal = useModal(modalIds.VacancyInfoModal);

  return {
    ...modal,
    show: (args: {
      vacancies: IVacancy[];
      id: number;
      mainDomain: string;
      vacancyEmail: string;
    }) => modal.show(args),
  };
};
